import { ProductsService } from "@/common/api.service";
import {
  FETCH_PRODUCTS,
  FETCH_PRODUCTS_BY_CATEGORY,
  FETCH_PRODUCT_DETAIL,
  SEARCH_PRODUCTS
} from "./actions.type";
import {
  FETCH_START,
  FETCH_END,
  SET_PRODUCTS,
  SET_PRODUCTS_BY_CATEGORY,
  SET_PRODUCT_DETAIL
} from "./mutations.type";

const state = {
  products: [],
  productsByCategory: [],
  productDetail: {},
  isProductLoading: true
};

const getters = {
  isProductLoading(state) {
    return state.isProductLoading;
  },
  products(state) {
    return state.products;
  },
  productsByCategory(state) {
    return state.productsByCategory;
  },
  productDetail(state) {
    return state.productDetail;
  }
};

const actions = {
  [FETCH_PRODUCTS]({ commit }) {
    commit(FETCH_START);
    return ProductsService.getAll("SkipCount=0&MaxResultCount=20")
      .then(({ data }) => {
        commit(FETCH_END);
        commit(SET_PRODUCTS, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [SEARCH_PRODUCTS]({ commit }, keyword) {
    commit(FETCH_START);
    return ProductsService.search(keyword, "SkipCount=0&MaxResultCount=20")
      .then(({ data }) => {
        commit(FETCH_END);
        commit(SET_PRODUCTS, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  [FETCH_PRODUCTS_BY_CATEGORY]({ commit }, slug) {
    commit(FETCH_START);
    return ProductsService.getByCategory(slug, "SkipCount=0&MaxResultCount=20")
      .then(({ data }) => {
        commit(FETCH_END);
        commit(SET_PRODUCTS_BY_CATEGORY, data.result.items);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_PRODUCT_DETAIL]({ commit }, slug) {
    commit(FETCH_START);
    const { data } = await ProductsService.getBySlug(slug);
    commit(FETCH_END);
    commit(SET_PRODUCT_DETAIL, data.result);
    const dataProds = await ProductsService.getByCategory(
      data.result.categoryId,
      "SkipCount=0&MaxResultCount=20"
    );
    commit(FETCH_END);
    const { result } = dataProds.data;
    commit(SET_PRODUCTS_BY_CATEGORY, result.items);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START](state) {
    state.isProductLoading = true;
  },
  [FETCH_END](state) {
    state.isProductLoading = false;
  },
  [SET_PRODUCTS](state, products) {
    state.products = products;
  },
  [SET_PRODUCTS_BY_CATEGORY](state, products) {
    state.productsByCategory = products;
  },
  [SET_PRODUCT_DETAIL](state, product) {
    state.productDetail = product;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
